import React from "react";
import "./CollapseButton.scss";

const CollapseButton = ({ 
  isOpen, 
  onClick, 
  addText = "Add another contact", 
  removeText = "Remove additional contact",
  color = "blue",
  variant = "expand" // 'expand' or 'collapse'
}) => {
  if (variant === "collapse") {
    return (
      <div
        className="form-collapse-table"
        data-component="collapse"
        onClick={onClick}
      >
        <div className="collapse-icon">
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 100 100"
              className="collapse-icon-svg"
            >
              <line
                x1="30"
                y1="30"
                x2="70"
                y2="70"
                stroke="rgba(245, 34, 45, 1)"
                strokeWidth="7"
              />
              <line
                x1="70"
                y1="30"
                x2="30"
                y2="70"
                stroke="rgba(245, 34, 45, 1)"
                strokeWidth="7"
              />
            </svg>
          </div>
          <div className="form-collapse-mid">
            {removeText}
          </div>
        </div>
      </div>
    );
  }

  // Default expand variant
  return (
    <div 
      className="form-collapse-table"
      data-component="collapse"
      onClick={onClick}
      style={{ display: isOpen ? 'none' : 'block' }}
    >
      <div className="plus-icon">
        <div className="plus-icon-svg">
          <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="36" height="36" rx="18" fill="black"/>
          <path d="M17.1 15.8H18.52V18.88H21.62V20.3H18.52V23.4H17.1V20.3H14.02V18.88H17.1V15.8Z" fill="white"/>
          </svg>
        </div>
        <div className="form-collapse-mid">
          {addText}
        </div>
      </div>
    </div>
  );
};

export default CollapseButton; 